import { gql } from '@apollo/client';
/**
 * @const SendOrderConfirmationMutation
 * @since 1.0.0
 */
export const SendOrderConfirmationMutation = gql `
  mutation SendOrderConfirmationMutation($input: SendOrderConfirmationInput!) {
    sendOrderConfirmation(input: $input)
  }
`;
